var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-container", attrs: { id: "uploadCustom" } },
    [
      _vm.showLimit
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-tag",
                    {
                      staticStyle: {
                        height: "auto",
                        "white-space": "break-spaces",
                        "font-size": "14px",
                        margin: "5px 0px",
                      },
                      attrs: { type: "warning" },
                    },
                    [_vm._v(_vm._s(_vm.limitText))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { attrs: { id: "uploadDiv" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 0 } },
                  [
                    _c("el-col", { attrs: { span: _vm.span } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "file-uploader",
                              attrs: {
                                accept: _vm.accept,
                                data: _vm.dataObj,
                                "auto-upload": _vm.autoUpload,
                                multiple: _vm.multiple,
                                "show-file-list": _vm.showFileList,
                                "btn-txt": _vm.btnTxt,
                                limit: _vm.limitFileCount,
                                "on-change": _vm.fileChange,
                                "on-exceed": _vm.handleExceed,
                                "on-error": _vm.handleUploadError,
                                "on-success": _vm.handleUploadSuccess,
                                "before-upload": _vm.beforeUpload,
                                "file-list": _vm.fileList,
                                "on-remove": _vm.handleRemove,
                                "on-preview": _vm.handlePreview,
                                drag: _vm.useDrag,
                                action: _vm.apiUrl,
                                "btn-style": _vm.btnStyle,
                                "show-limit": false,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  ref: "selectedRef",
                                  attrs: { size: "mini", type: _vm.btnStyle },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.btnTxt ? _vm.btnTxt : "選取檔案"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [_vm._t("secondButton")],
                        2
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }